export default __webpack_public_path__ + "static/media/fr-asia-14.2dbbe363.jpg";